import { createRootegraClient } from '../shared/supabaseClient';
import {
  loadActiveContext,
  makeContextFetch,
  saveActiveContext,
} from '../shared/activeContext';

// Backbar is always the admin hat. Pin the active context once on boot so
// every request carries x-active-role: admin (the header filters among roles
// the user actually holds — it never grants anything).
saveActiveContext({ role: 'admin', salonId: null });

export const supabase = createRootegraClient({
  auth: {
    // Magic-link sign-in lands with auth params in the URL.
    detectSessionInUrl: true,
  },
  global: {
    // Falls back to the pinned admin context even if localStorage is unavailable.
    fetch: makeContextFetch(() => loadActiveContext() ?? { role: 'admin', salonId: null }),
  },
});
